import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';

const publicUrl = process.env.PUBLIC_URL || '';
const publicBaseUrl = publicUrl
  ? new URL(publicUrl.replace(/\/$/, '') + '/', window.location.origin).toString()
  : window.location.origin;

const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: publicBaseUrl,
  post_logout_redirect_uri: publicBaseUrl,
  // read scopes from env so we only request scopes the Cognito app client allows
  scope: process.env.REACT_APP_OIDC_SCOPE || 'openid',
  // use Authorization Code flow (with PKCE) which is recommended for SPAs
  response_type: 'code',
  // disable automatic silent renew to prevent background token requests from interfering
  automaticSilentRenew: false,
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider {...(oidcConfig as any)}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
